<template>
    <div :class="{ backgroundPage: dealer.dealer !== 'CALIAGENERIC' && (mode === 'home' || mode === 'logoutHome') }">
        <mainindex>
            <div v-if="alertRotate" class="d-flex align-items-center" style="position: fixed; top: 0; right: 0; bottom: 0; left: 0; background: #000; z-index: 9999">
                <div class="mx-auto">
                    <img :src="imgRotate" alt="Calia" />
                    <p class="lead text-white text-center" v-text="_trans('Please rotate your device')"></p>
                </div>
            </div>
            <div v-if="islogmode" class="log">
                <d-close @close="islogmode = !islogmode" />
                <mainlog></mainlog>
            </div>
            <div v-if="!islogmode" class="content">
                <!--HEADER-->
                <page-header v-if="mode !== 'home' && mode !== 'logoutHome' && mode !== 'itemsearch'" :cur-page="mode" :menu-tree="menu" @nav="go($event)" @openlogspanel="toggleLogsPanel" @save-prj="savePrj()" @new-prj="newPrj"></page-header>
                <!--HEADER-->

                <!--BODY-->
                <div :class="[paddingClass]" class="body">
                    <router-view v-if="$route.name !== null"></router-view>
                    <div v-else>
                        <template v-if="mode === 'home'">
                            <home @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects')"></home>
                        </template>
                        <template v-else-if="mode === 'logoutHome'">
                            <home :dologout="true" @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects')"></home>
                        </template>
                        <template v-else-if="mode === 'startprj'">
                            <start-prj confirm-room-type @nav="go($event)"></start-prj>
                        </template>
                        <template v-else-if="mode === 'projects'">
                            <div class="container" style="margin-top: 70px">
                                <div v-if="user.seller > 0" class="mb-3">
                                    <notifications></notifications>
                                </div>
                                <b-tabs content-class="">
                                    <!--Levels available: 2, 3, 5, 6-->
                                    <!--My View-->
                                    <b-tab :title="_trans('My View')" active>
                                        <div>
                                            <!-- MY -->
                                            <prj-finder
                                                :cols="[
                                                    { id: 'id', title: 'id', order: 0 },
                                                    { id: 'des', title: _trans('reference'), order: 6 },
                                                    { id: 'status', title: _trans('status'), order: 4 },
                                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                    { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                    { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                    { id: 'ownermail', title: _trans('owner'), order: 10 },
                                                    { id: 'open', title: null },
                                                    { id: 'assign', title: null },
                                                    { id: 'delete', title: null },
                                                    { id: 'close', title: null }
                                                ]"
                                                :rows-number="10"
                                                :title="_trans('My projects')"
                                                filter="MY"
                                                order-by="11D"
                                                @open="openPrj($event)"
                                            ></prj-finder>
                                            <!-- INVOLVED -->
                                            <prj-finder
                                                :cols="[
                                                    { id: 'id', title: 'id', order: 0 },
                                                    { id: 'des', title: _trans('reference'), order: 6 },
                                                    { id: 'status', title: _trans('status'), order: 4 },
                                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                    { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                    { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                    { id: 'ownermail', title: _trans('owner'), order: 10 },
                                                    { id: 'open', title: null },
                                                    { id: 'assign', title: null },
                                                    { id: 'delete', title: null },
                                                    { id: 'reject', title: null },
                                                    { id: 'close', title: null }
                                                ]"
                                                :rows-number="10"
                                                :title="_trans('Involved')"
                                                filter="INVOLVED"
                                                order-by="11D"
                                                @open="openPrj($event)"
                                            ></prj-finder>
                                        </div>
                                    </b-tab>
                                    <!--Existing Projects-->
                                    <b-tab v-if="user.seller > 3" :title="_trans('Existing Projects')">
                                        <div>
                                            <div v-if="user.seller !== 5">
                                                <!-- OTHERPRJ -->
                                                <prj-finder
                                                    :cols="[
                                                        { id: 'id', title: 'id', order: 0 },
                                                        { id: 'des', title: _trans('reference'), order: 6 },
                                                        { id: 'status', title: _trans('status'), order: 4 },
                                                        { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                        { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                        { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                        { id: 'ownermail', title: _trans('owner'), order: 10 },
                                                        { id: 'open', title: null },
                                                        { id: 'assign', title: null },
                                                        { id: 'close', title: null }
                                                    ]"
                                                    :rows-number="10"
                                                    :title="_trans('Other projects in my store')"
                                                    filter="OTHERPRJ"
                                                    order-by="11D"
                                                    @open="openPrj($event)"
                                                ></prj-finder>
                                            </div>
                                            <div v-else>
                                                <!-- ORDERED -->
                                                <prj-finder
                                                    :cols="[
                                                        { id: 'id', title: 'id', order: 0 },
                                                        { id: 'des', title: _trans('reference'), order: 6 },
                                                        { id: 'status', title: _trans('status'), order: 4 },
                                                        { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                        { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                        { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                        { id: 'ownermail', title: _trans('owner'), order: 10 },
                                                        { id: 'open', title: null },
                                                        { id: 'assign', title: null },
                                                        { id: 'close', title: null }
                                                    ]"
                                                    :rows-number="10"
                                                    :title="_trans('Other projects in my store')"
                                                    filter="ORDERED"
                                                    order-by="11D"
                                                    @open="openPrj($event)"
                                                ></prj-finder>
                                            </div>
                                            <div v-if="user.seller >= 5">
                                                <!-- UNASSIGNED -->
                                                <prj-finder
                                                    :cols="[
                                                        { id: 'id', title: 'id', order: 0 },
                                                        { id: 'des', title: _trans('reference'), order: 6 },
                                                        { id: 'status', title: _trans('status'), order: 4 },
                                                        { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                        { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                        { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                        { id: 'ownermail', title: _trans('owner'), order: 10 },
                                                        { id: 'open', title: null },
                                                        { id: 'assign', title: null }
                                                    ]"
                                                    :rows-number="10"
                                                    :title="_trans('Unassigned projects')"
                                                    filter="UNASSIGNED"
                                                    order-by="11D"
                                                    @open="openPrj($event)"
                                                ></prj-finder>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <!--Closed/Deleted-->
                                    <b-tab v-if="user.seller >= 5" :title="_trans('Closed/Deleted')">
                                        <div>
                                            <!-- CLOSED -->
                                            <prj-finder
                                                :cols="[
                                                    { id: 'id', title: 'id', order: 0 },
                                                    { id: 'des', title: _trans('reference'), order: 6 },
                                                    { id: 'status', title: _trans('status'), order: 4 },
                                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                    { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                    { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                    { id: 'ownermail', title: _trans('owner'), order: 10 }
                                                ]"
                                                :rows-number="10"
                                                :title="_trans('Closed projects')"
                                                filter="CLOSED"
                                                order-by="11D"
                                                @open="openPrj($event)"
                                            ></prj-finder>
                                            <!-- INACTIVE -->
                                            <prj-finder
                                                :cols="[
                                                    { id: 'id', title: 'id', order: 0 },
                                                    { id: 'des', title: _trans('reference'), order: 6 },
                                                    { id: 'status', title: _trans('status'), order: 4 },
                                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                                    { id: 'shopdes', title: _trans('shop'), order: 8 },
                                                    { id: 'usermail', title: _trans('assigned to'), order: 9 },
                                                    { id: 'ownermail', title: _trans('owner'), order: 10 },
                                                    { id: 'open', title: null },
                                                    { id: 'assign', title: null }
                                                ]"
                                                :rows-number="10"
                                                :title="_trans('Deleted projects')"
                                                filter="INACTIVE"
                                                order-by="11D"
                                                @open="openPrj($event)"
                                            ></prj-finder>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </template>
                        <template v-else-if="mode === 'notifications'">
                            <notifications></notifications>
                        </template>
                        <template v-else-if="mode === 'itemsearch'">
                            <article-search :allow-gallery="true" @nav="go($event)" @openlogspanel="toggleLogsPanel"></article-search>
                        </template>
                        <template v-else-if="mode === 'renders'">
                            <renders @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'configurator'">
                            <configure @nav="go($event)"></configure>
                        </template>
                        <template v-else-if="mode === '3dview'">
                            <view3d ref="conf3d" :load-header-on-start="true" @messagetoiframe="messageToParentEmitted($event)" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === '2dview'">
                            <view2d ref="conf2d" :load-header-on-start="true" use-old-sidebar @messagetoiframe="messageToParentEmitted($event)" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'compositions'">
                            <compositions :apply-header="false" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'offerview'">
                            <offer @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'summary'">
                            <prj-summary @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'customerinfo'">
                            <customer-info />
                        </template>
                        <template v-else-if="mode === 'prjlog'">
                            <prj-log />
                        </template>
                        <template v-else-if="mode === 'delivery'">
                            <delivery />
                        </template>
                        <template v-else-if="mode === 'promotions'">
                            <promotions />
                        </template>
                        <template v-else-if="mode === 'json'">
                            <d-json :value="prj" />
                        </template>
                        <template v-else-if="mode === 'myprofile'">
                            <my-profile />
                        </template>
                        <template v-else>
                            <h1>::::{{ mode }}::::</h1>
                        </template>
                    </div>
                </div>
                <!--BODY-->
            </div>
            <home v-else @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects')"></home>
        </mainindex>
        <d-msg v-if="askend" sizex="3fr" text="close current session" title="CloseSession" yesno @close="disconnect($event)" />
        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>
    </div>
</template>

<script>
    import "../../../scss/calia.scss";
    // import iframeEmbedded from "@custom/IframeEmbedded";
    import { App, BrowserDetector } from "@3cad/nextcore";
    import { bus } from "@store/dau";
    import index from "@configurator/index";
    import embedded from "@configurator/embedded";
    // import NextModals from "@dialogs/index";
    // import { V_ModalAddLinks, V_ModalDClass, V_ModalPopVar } from "@vuectrls/controllers";
    // import { DevExpressAPI } from "@devexpress/devexpressAPI";
    import imgRotate from "@assets/calia/img/imgRotate.gif";

    export default {
        mixins: [index, embedded],
        data() {
            return {
                menu: require("@assets/calia/json/menu.json"),
                lockUndo: false,
                imgRotate: imgRotate,
                alertRotate: false
            };
        },
        computed: {
            paddingClass() {
                switch (this.mode) {
                    case "home":
                    case "projects":
                    case "itemsearch":
                        return "no-menu";
                    default:
                        return "mid-menu";
                }
            },
            dealer() {
                return this.$store.getters["calia/getDealer"];
            }
        },
        watch: {
            user: {
                handler: function (newVal) {
                    // TODO: Guardare i seguenti link
                    // https://en.wikipedia.org/wiki/Language_localisation#Language_tags_and_codes
                    // http://www.rfc-editor.org/rfc/bcp/bcp47.txt#
                    // https://www.w3.org/International/articles/language-tags/
                    if (newVal.shop && newVal.shop.country.toUpperCase() === "US") {
                        this.preferences.config.measures.length = "EX";
                        this.preferences.config.measures.volume = "CI";
                        this.preferences.config.measures.weight = "LB";
                        this.preferences.config.currency = "USD";
                    } else if (newVal.shop && newVal.shop.country.toUpperCase() === "CA") {
                        this.preferences.config.measures.length = "EX";
                        this.preferences.config.measures.volume = "CI";
                        this.preferences.config.measures.weight = "LB";
                        this.preferences.config.currency = "CAD";
                    } else if (newVal.shop && newVal.shop.country.toUpperCase() === "GB") {
                        //  this.preferences.config.measures.length = 'EX';
                        //  this.preferences.config.measures.volume = 'CI';
                        //  this.preferences.confi g.measures.weight = 'LB';
                        this.preferences.config.currency = "GBP";
                    } else if (newVal.shop && newVal.shop.country.toUpperCase() === "UK") {
                        // this.preferences.config.measures.length = 'EX';
                        // this.preferences.config.measures.volume = 'CI';
                        // this.preferences.config.measures.weight = 'LB';
                        this.preferences.config.currency = "GBP";
                    } else if (newVal.shop && newVal.shop.country.toUpperCase() === "EN") {
                        // this.preferences.config.measures.length = 'EX';
                        // this.preferences.config.measures.volume = 'CI';
                        // this.preferences.config.measures.weight = 'LB';
                        this.preferences.config.currency = "GBP";
                    } else if (newVal.shop && newVal.shop.country.toUpperCase() === "CH") {
                        this.preferences.config.currency = "CHF";
                    } else if (newVal.shop && newVal.shop.country.toUpperCase() === "JP") {
                        this.preferences.config.currency = "JPY";
                    } else {
                        this.preferences.config.measures.length = "MM";
                        this.preferences.config.measures.volume = "CR";
                        this.preferences.config.measures.weight = "KG";
                        this.preferences.config.currency = "EUR";
                    }
                },
                deep: true
            }
        },
        beforeCreate() {
            let isMobile = false;
            let ua = navigator.userAgent;
            console.log("User Agent: ", ua);
            if (ua.match(/Android/i) || ua.match(/BlackBerry/i) || ua.match(/iPhone|iPad|iPod/i) || ua.match(/Opera Mini/i) || ua.match(/IEMobile/i)) isMobile = true;
            let browser = new BrowserDetector().getBrowser();
            if (!isMobile && browser !== null && browser !== "chrome") {
                // verificare this.isChrome = !!window.chrome && (!!chrome.webstore || !!chrome.runtime);
                // this.$router.push({path: "/unsupported"});
            }
            let dealer = process.dau._BUILD_TYPE;
            this.$store.registerModule("calia", {
                namespaced: true,
                state: {
                    confOnly3d: null,
                    openGalleryAssociated: false,
                    galleryOpened: false,
                    dealer: { isDealer: dealer.toLowerCase() !== "calia", dealer: dealer },
                    exportToEsyStore: false
                },
                getters: {
                    getConfOnly3d: state => state.confOnly3d,
                    getOpenGalleryAssociated: state => state.confOnly3d,
                    getGalleryOpened: state => state.galleryOpened,
                    getDealer: state => state.dealer,
                    getExportToEsyStore: state => state.exportToEsyStore
                },
                mutations: {
                    setConfOnly3d(state, payload) {
                        state.confOnly3d = payload;
                    },
                    setOpenGalleryAssociated(state, payload) {
                        state.openGalleryAssociated = payload;
                    },
                    setGalleryOpened(state, payload) {
                        state.galleryOpened = payload;
                    },
                    setExportToEsyStore(state, payload) {
                        state.exportToEsyStore = payload;
                    }
                }
            });
        },
        mounted() {
            this.doOnOrientationChange();
            this.$nextTick(function () {
                window.addEventListener("orientationchange", this.doOnOrientationChange);
            });
        },
        methods: {
            //region IFRAME
            requestFromParent(action, data) {
                if (this.guestAdmitted) {
                    if (action) {
                        console.info("%cRequest FROM parent", "color:yellow;", { action, data });
                        let newProject, iCatalog, iModel, iHeader, iClassification, iArticle, iSide, idProject, idGallery;
                        switch (action) {
                            case "openProject":
                                /*
                                let example = {
                                    "id": "10038"
                                };
                                */
                                // Check id Project
                                if (!data.id) {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Missing id project"
                                    });
                                    return;
                                }
                                idProject = parseInt(data.id);
                                if (this.mode === "3dview") this.go("home");
                                this.openPrj(idProject);
                                break;
                            case "saveProject":
                                /*
                                let example = {
                                  "des": "saved from APPDELMOBILE"
                                };
                                */
                                let prjDescription = "";
                                if (data.hasOwnProperty("des")) prjDescription = data.des || "";
                                if (this.prj.des === "" && prjDescription !== "") this.prj.des = prjDescription;
                                if (this.prj.isopen && this.prj.rows.length > 0) {
                                    this.savePrj()
                                        .then(() => {
                                            this.responseToParent({
                                                status: 0,
                                                action: action,
                                                msg: this.prj.id
                                            });
                                        })
                                        .catch(error => {
                                            console.error(action, error);
                                            this.responseToParent({
                                                status: 1,
                                                action: action,
                                                msg: error
                                            });
                                        });
                                } else {
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "Nothing to save"
                                    });
                                }
                                break;
                            case "takePicture":
                                /*
                                let example = {
                                    "width": 1000,
                                    "height": 500
                                };
                                */
                                if (this.prj && this.prj.isopen) {
                                    let width = "width" in data ? parseInt(data.width) : 1000;
                                    let height = "height" in data ? parseInt(data.height) : 1000;
                                    let newWindows = false;
                                    let bw = 0;
                                    let keepEffect = true;
                                    let img = App.iCad.scattaFoto(width, height, newWindows, bw, keepEffect);
                                    this.responseToParent(
                                        {
                                            status: 0,
                                            action: action,
                                            content: img
                                        },
                                        true
                                    );
                                } else {
                                    // alert("No project open")
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "No project open"
                                    });
                                }
                                break;
                            case "getJsonProject":
                                /*
                                let example = {};
                                */
                                if (this.prj && this.prj.isopen) {
                                    // let project = JSON.stringify(this.prj.getJson());
                                    App.projectManager.recomputePrices().then(response => {
                                        // let encodePrj = this.prj.getJson();
                                        let encodePrj = JSON.parse(JSON.stringify(this.prj.getJson()));
                                        encodePrj.measures = this.preferences.config.measures;
                                        encodePrj.currency = this.preferences.config.currency;
                                        console.log("getJsonProject:", encodePrj);
                                        this.responseToParent(
                                            {
                                                status: 0,
                                                action: action,
                                                content: encodePrj
                                            },
                                            true
                                        );
                                    });
                                } else {
                                    // alert("No project open")
                                    this.responseToParent({
                                        status: 1,
                                        action: action,
                                        msg: "No project open"
                                    });
                                }
                                break;
                            default:
                                console.log(data);
                                this.responseToParent({
                                    status: 1,
                                    action: action,
                                    msg: "Unknown action"
                                });
                                break;
                        }
                    } else {
                        // console.log("Missing Action");
                    }
                } else {
                    this.responseToParent({
                        status: 1,
                        action: "APP",
                        msg: "This site doesn't allow guest users!"
                    });
                }
            },
            responseToParent(data, isObj = false) {
                if (data) {
                    let status = parseInt(data.status);
                    let action = data.action;
                    let content = data.content || data.msg;
                    if (isObj) content = JSON.stringify(data.content);
                    if (this.iframeCom) {
                        let msg = {
                            status: status,
                            action: action,
                            msg: content
                        };
                        this.iframeCom.sendMsg(msg);
                        let color = "color:blue;";
                        if (msg.status === 0) {
                            color = "color:green;";
                        } else if (msg.status === 1) {
                            color = "color:red;";
                        }
                        if (isObj) {
                            msg.msg = JSON.parse(content);
                        }
                        console.info("%cMessage/response TO parent", color, msg);
                    }
                }
            },
            messageToParentEmitted(data) {
                if (typeof data === "object" && data !== null) {
                    if ("isObj" in data) {
                        this.responseToParent(data.data, data.isObj);
                    } else {
                        this.responseToParent(data);
                    }
                } else {
                    this.responseToParent(data);
                }
            },
            //endregion
            getDataValida() {
                let valueToReturn = new Date();
                let numberOfDaysToAdd = 70;
                valueToReturn.setDate(valueToReturn.getDate() + numberOfDaysToAdd);
                let dd = valueToReturn.getDate();
                let mm = valueToReturn.getMonth() + 1;
                let yyyy = valueToReturn.getFullYear();
                if (dd < 10) dd = "0" + dd;
                if (mm < 10) mm = "0" + mm;
                valueToReturn = dd + "/" + mm + "/" + yyyy;
                return valueToReturn;
            },
            resetCustomerParams() {
                this.$set(this.prj, "currency", this.preferences.config.currency || "EUR");
                this.$set(this.prj, "testaCalia", {
                    xDataC: this.getDataValida(),
                    xMagg: 0,
                    xSC1: 0,
                    xSC2: 0,
                    xSC3: 0,
                    xSC4: 0,
                    xTrasporto: 0,
                    xMontaggio: 0,
                    xIva: 0
                });
                this.$set(this.prj, "breadcrumb", []);
                this.$set(this.prj, "customerFields", {
                    confOnly3d: null,
                    galleryOpened: false
                });
            },
            onNewProject() {
                // this.$store.commit("calia/setOpenGalleryAssociated", true);
                // this.$store.commit("calia/setConfOnly3d", null);
                if (this.preferences.config.customization.enableWizard && !this.user.guest) this.go("startprj");
                else this.go("itemsearch");
            },
            openPrj(id) {
                let loadPrj = () => {
                    if (localStorage["next_goto"]) delete localStorage["next_goto"];
                    this.$store.commit("startLoading", { msg: this._trans("Loading project") });
                    this.resetCustomerParams();
                    this.$store
                        .dispatch("project/load", { id: id })
                        .then(prj => {
                            this.pricesIncrease = prj.pricesIncrease;
                            if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");
                            if (!prj.customerFields.hasOwnProperty("confOnly3d")) {
                                this.$set(this.prj, "customerFields", {
                                    confOnly3d: true,
                                    galleryOpened: false
                                });
                            }
                            this.$store.commit("calia/setConfOnly3d", this.prj.customerFields.confOnly3d);
                            // this.$store.commit("calia/setOpenGalleryAssociated", false);
                            this.prj.listid = this.user.shop.pricelist;
                            bus.$emit("stopLoading");
                            //region imposta selezioni "Calia"
                            let cad = this.$store.state.cad;
                            cad.iCad.setMultiSelectionType(2);
                            let multiSelectionState = cad.iCad.getMultiSelectionState();
                            if (!multiSelectionState) cad.iCad.setMultiSelection(true);
                            //endregion
                            this.onProjectLoaded();
                        })
                        .catch(() => {
                            bus.$emit("stopLoading");
                        });
                };

                if (this.prj.isopen) {
                    this.$3cadAsk({
                        title: this._trans("Project not saved"),
                        body: this._trans("Save current project?"),
                        okTitle: this._trans("Yes"),
                        cancelTitle: this._trans("No")
                    })
                        .then(data => {
                            this.savePrj().then(loadPrj);
                        })
                        .catch(mode => {
                            if (mode === 0) loadPrj();
                        });
                } else {
                    loadPrj();
                }
            },
            onProjectLoaded() {
                if (this.isIntoIframe) {
                    this.responseToParent({
                        status: 0,
                        action: "openProject",
                        msg: "Project loaded correctly"
                    });
                }
                this.go("offerview");
            },
            doOnOrientationChange() {
                // alert(window.orientation);
                switch (window.orientation) {
                    case 0:
                    case 180:
                        // alert("portrait");
                        this.alertRotate = true;
                        break;
                    case 90:
                    case -90:
                        // alert('landscape');
                        this.alertRotate = false;
                        break;
                    default:
                        // alert("undefined");
                        this.alertRotate = false;
                        break;
                }
            },
            newPrj(is3D) {
                let initPrj = () => {
                    if (localStorage["next_goto"]) {
                        delete localStorage["next_goto"];
                    }
                    if (this.preferences.config.customerAssignment && !this.user.guest) {
                        this.$3cadComponent({
                            title: this._trans("Customer assignment"),
                            component: "_retrieveCustomer",
                            componentData: {},
                            componentEvents: ["select", "skip"]
                        }).then(({ event, data }) => {
                            this.$store.commit("project/empty");
                            this.$store.commit("erp/reset");
                            this.resetCustomerParams();

                            //Empty breadcrumb store
                            if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");

                            let customerData = data;
                            if (customerData) {
                                this.prj.customercod = customerData.email;
                            }

                            this.prj.isopen = true;
                            this.onNewProject();
                        });
                    } else {
                        this.$store.commit("project/empty");
                        this.$store.commit("erp/reset");
                        this.resetCustomerParams();
                        if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");
                        this.prj.isopen = true;
                        this.$store.commit("calia/setConfOnly3d", is3D);
                        this.$set(this.prj.customerFields, "confOnly3d", this.$store.getters["calia/getConfOnly3d"]);
                        this.onNewProject();
                    }
                };
                if (this.prj.isopen) {
                    if (this.prj.status !== "ORDERED") {
                        this.$3cadAsk({
                            title: this._trans("Project not saved"),
                            body: this._trans("Save current project?"),
                            okTitle: this._trans("Yes"),
                            cancelTitle: this._trans("No")
                        })
                            .then(data => {
                                this.$set(this.prj, "breadcrumb", this.$store.state.searchArticle.breadcrumb);
                                this.prj.customerFields.confOnly3d = this.$store.getters["calia/getConfOnly3d"];
                                this.savePrj().then(initPrj);
                            })
                            .catch(mode => {
                                if (mode === 0) initPrj();
                            });
                    } else {
                        initPrj();
                    }
                } else initPrj();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .no-menu {
        padding-top: 0;
    }

    .mid-menu {
        /*padding-top: 70px;*/
        padding-top: 0;
        @include media-breakpoint-down(md) {
        }
    }

    .full-menu {
        padding-top: 8.15rem;
        @include media-breakpoint-down(md) {
            padding-top: 5.15rem;
        }
    }

    .username {
        position: absolute;
        right: 20px;
        bottom: 5px;
    }

    .catalog {
        position: absolute;
        right: 200px;
        width: 120px;
        height: 38px;
        color: $white;
        border: 0;
        background-color: $color;
    }

    .catalogoption {
        font-size: 0.8em;
        font-weight: normal;
    }

    .body {
    }

    .close {
        z-index: 10;
        padding-top: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/custom/calia/start.vue